module.exports = __webpack_public_path__ + "img/edit.1f05be08.svg";